import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import environmentVariables from "../config/environmentVariables";
const SuccessIcon =`${environmentVariables?.cdnUrl}successicon.png`
import TransactionLoader from "./TransactionLoader/TransactionLoader";
import { userInfoContext } from "../context/userInfoContext";
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -25px;
    right: -15px;
  }

  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
  @media (max-width: 600px) {
    // font-size: 20px;
    margin-bottom: 3px;
  }
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  display: flex;
  color: #bbb;
  @media (max-width: 600px) {
    font-size: 12px;
  }
`;
const NftNameConfirm4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;
const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;
const AmountHead = styled.div`
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 5px;
  text-transform: capitalize;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 30px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 50%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
`;
const AmountSubHead = styled.div`
  font-size: 16px;
  color: #6c6c6c;
  text-transform: capitalize;
`;
const PaymentRedirectPage = () => {
  const useStyles = makeStyles((theme) => ({
    customButton: {
      padding: "50px",
      backgroundColor: "#2a2a2a",
      border: "1px solid #484848",
      borderRadius: "10px",
      color: "#fff",
      minWidth: "360px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "580px",
      "@media (max-width: 768px)": {
        minWidth: "360px",
      },
      "@media (max-width: 600px)": {
        maxWidth: "220px",
        minWidth: "350px",
        padding: "40px 30px",
        backgroundColortransparent: true,
      },
      "@media (max-width: 400px)": {
        maxWidth: "220px",
        minWidth: "320px",
        padding: "40px 30px",
        backgroundColortransparent: true,
      },
    },
  }));
  const ImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
  `;
  const Image = styled.img`
    width: 12%;
  `;
  const NftNameConfirmHead = styled.div`
    /* font-size: 32px;
    font-weight: 500; */
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1.5px;
    color: #8d8d8d;
    padding: 0 20px;
    // text-align: center;
  `;
  const CopyIcon = styled.div`
    position: relative;
    color: white;
    cursor: pointer;
    padding: 0 0 0 15px;
    @media (max-width: 425px) {
      padding: 0 0 0 5px;
    }
  `;
  const ToolTipSpan = styled.span`
    width: 80px;
    background-color: #f3eded;
    color: #080808;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 145%;
    margin-left: -60px;
    opacity: 1;
    font-weight: 700;
    transition: opacity 0.3s;
    ::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #f3eded transparent transparent transparent;
    }
  `;
  const NftNameConfirm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    padding-top: 20px;
    border-bottom: 1px solid #484848;
    border-top: 1px solid #484848;
    justify-content: center;
    ${(p) => {
      p.ConfirmPopup &&
        `
   justify-content: flex-start;
  `;
    }}
  `;
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [transactionHash, setTransactionHash] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [message, setMessage] = useState("");
  const [tokenName,setTokenName]=useState('');
  const [isTransferError, setIsTransferError] = useState(false);

  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)

  const [isTokenTransferFailed, setIsTokenTransferFailed] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const CopyAddress = () => {
    try {
      if (transactionHash) {
        navigator.clipboard.writeText(transactionHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error copying text:", error);
    }
  };
  const explorerHandler = () => {
    let explorerUrl = "";

    explorerUrl = `https://polygonscan.com/tx/${transactionHash.hash}`;

    if (transactionHash.hash) {
      window.open(explorerUrl, "_blank");
    } else {
      console.error("Invalid token name or transaction hash");
    }
  };
  const DialogStyledUpdate = styled(Dialog)``;

  const transferToken = (trans_token, payGateway) => {
    setIsTokenTransferFailed(true);
    // let data = {
    //   transaction_token: trans_token,
    //   payment_gateway: payGateway,
    // };

    // let config = {
    //   method: "post",
    //   maxBodyLength: Infinity,
    //   url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/transfer_token`,
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   data: data,
    // };

    // axios
    //   .request(config)
    //   .then((response) => {
    //     // toast.success("Token Transferred");
    //     setTransactionHash(response.data);
    //     setSuccessPopup(true);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     // toast.error(error?.response?.data?.message || error?.message);
    //     setIsTokenTransferFailed(true);
    //   });
  };
  const verifyPayment = () => {
    const transfer_token = params.get("TransactionToken");
    const ref = params.get("ref");
    if (transfer_token) {
      let data = {
        transaction_token: transfer_token,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/verify_trx`,
        headers: {
          "Content-Type": "application/json",
          authorization:`Bearer ${userAccInfo}`
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data?.result?.API3G?.Result?._text);
          if (response.data?.result?.API3G?.Result?._text == "000") {
            // toast.success("Token is transferred to the account");
            setTokenName(response?.data?.token=="MLD"||response?.data?.token=="LORD"?`$${response?.data?.token||"MLD"}`:`${response?.data?.token||"MLD"}`)
            transferToken(transfer_token, "dpo");

            // setLoading(false);

            // navigate("/");
          } else {
            // toast.error("Something went wrong with payment");
            setMessage("Something went wrong with payment");
            setIsTransferError(true);
            setLoading(false);
            // navigate("/");
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          // toast.error(error?.response?.data?.message || error?.message);
          // setSuccessPopup(true);
          setIsTransferError(true);
          setMessage(error?.response?.data?.message || error?.message);

          // navigate("/");
        });
    } else if (ref) {
      let data = JSON.stringify({
        trans_ref: ref,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/verify_pay_network`,
        headers: {
          "Content-Type": "application/json",
          authorization:`Bearer ${userAccInfo}`
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response?.data?.success == true) {
            transferToken(ref, "network");
            setTokenName(response?.data?.token=="MLD"||response?.data?.token=="LORD"?`$${response?.data?.token}||"MLD"`:`${response?.data?.token}||"MLD"`)
          } else {
            // toast.error(response?.data?.message);
            setMessage(response?.data?.message);
            setIsTransferError(true);
            // transferToken(ref, "network");

            setLoading(false);
          }
        })
        .catch((error) => {
          // transferToken(ref, "network");

          setLoading(false);
          console.log(error);
        });
    }
  };
  useEffect(() => {
    if (!isTokenTransferFailed && !isTransferError) {
      verifyPayment();
    }
  }, []);
  return (
    <div>
      {loading && <TransactionLoader />}
      <DialogStyledUpdate
        open={successPopup}
        onClose={() => {
          setSuccessPopup(false);
          navigate("/");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel
          onClick={() => {
            setSuccessPopup(false);
            navigate("/");
          }}
          color="primary"
        >
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <div>
            <ImageWrapper>
              <Image src={SuccessIcon} />
            </ImageWrapper>

            <DialogTitle
              id="alert-dialog-title"
              style={{
                textAlign: "center",
                fontSize: "36px",
                fontWeight: "500",
                padding: "0",
                color: "#fff",
              }}
            >
              Transaction Successful
            </DialogTitle>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#cd2222",
                  textTransform: "capitalize",
                }}
                onClick={explorerHandler}
              >
                view on explorer{" "}
                <span>
                  <i class="fa-solid fa-arrow-up-right-dots"></i>
                </span>
              </div>
            </div>
          </div>
          <DialogContent style={{ padding: "0 0 40px" }}></DialogContent>

          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>Transaction Hash:</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead2>
              {`${transactionHash?.hash?.slice(
                0,
                5
              )}....${transactionHash?.hash?.slice(-5)}` || ``}
              <CopyIcon onClick={CopyAddress}>
                <i class="fa-solid fa-copy"></i>
                {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
              </CopyIcon>
            </NftAmountConfirmSubHead2>
          </NftAmountConfirmHeadPur>

          <DialogActions>
            <NftNameConfirm4>
              <NftNameConfirmSubHead>
                {`${transactionHash?.paymentData?.token_name} Transferred`}{" "}
              </NftNameConfirmSubHead>
              <AmountHead>
                {parseFloat(transactionHash?.paymentData?.token_amount).toFixed(
                  4
                )}
              </AmountHead>
              <AmountSubHead>{`${
                transactionHash?.paymentData?.createdAt.split("T")[0]
              }`}</AmountSubHead>
            </NftNameConfirm4>
          </DialogActions>
        </div>
      </DialogStyledUpdate>
      <DialogStyledUpdate
        open={isTransferError}
        onClose={() => {
          setIsTransferError(false);
          navigate("/");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel
          onClick={() => {
            setIsTransferError(false);
            navigate("/");
          }}
          color="primary"
        >
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <NftNameConfirm>
            <NftNameConfirmHead>{message}</NftNameConfirmHead>
            {/* <BuyPop>Click here to Buy</BuyPop> */}
          </NftNameConfirm>
        </div>
      </DialogStyledUpdate>
      <DialogStyledUpdate
        open={isTokenTransferFailed}
        onClose={() => {
          setIsTokenTransferFailed(false);
          navigate("/");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel
          onClick={() => {
            setIsTokenTransferFailed(false);
            navigate(`/trxhistory?token=${tokenName}`);
          }}
          color="primary"
        >
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <div>
            <ImageWrapper>
              <Image src={SuccessIcon} />
            </ImageWrapper>

            <DialogTitle
              id="alert-dialog-title"
              style={{
                textAlign: "center",
                fontSize: "36px",
                fontWeight: "500",
                padding: "0",
                color: "#fff",
              }}
            >
              Payment Successful
            </DialogTitle>
          </div>
          <DialogContent style={{ padding: "0 0 20px" }}></DialogContent>
          <NftNameConfirm>
            <NftNameConfirmHead style={{ textAlign: "center" }}>
              Your Tokens will reflect in your wallet within 15 to 20 minutes
            </NftNameConfirmHead>
          </NftNameConfirm>
          {/* <ButtonConfirm>Contact Us</ButtonConfirm> */}
        </div>
      </DialogStyledUpdate>
    </div>
  );
};

export default PaymentRedirectPage;
